import React, { useRef } from "react";
import { observer } from "mobx-react";
import { Grid, Box } from "@mui/material";
import { GroupContainer } from "../../../../common/components";
import { FormToolbox } from "../../../../common/controls/forms/FormToolbox";
import { useReactToPrint } from "react-to-print";

import { useRootStore } from "../../../../store/contexts";
import { ShowMultiLine } from "../../../common/controls";
import { ShowNumber } from "../../../common/controls";
import { FormControl } from "@mui/material";

export type ShowcaseLineViewFormProps = {
  onPrint?: (handlePrint: () => void) => void;
  onCancel?: () => void;
  onEdit?: () => void;
  showToolbox?: boolean;
  conceptValue?: { displayId: string; id: string } | null;
  concept: string;
  quantityValue?: { displayId: string; id: string } | null;
  quantity: number;
  unitPriceValue?: { displayId: string; id: string } | null;
  unitPrice: number;
  noteValue?: { displayId: string; id: string } | null;
  note: string;
};

export const ShowcaseLineViewForm: React.FC<ShowcaseLineViewFormProps> =
  observer(
    ({
      onPrint = () => {},
      onCancel = () => {},
      onEdit,
      showToolbox = true,
      concept = "",
      quantity = 0,
      unitPrice = 0,
      note = "",
    }) => {
      const rootStore = useRootStore();
      const { langStore } = rootStore;

      const componentRef = useRef(null);
      const handlePrint = useReactToPrint({
        content: () => componentRef.current,
      });

      return (
        <Grid>
          {showToolbox && (
            <FormToolbox
              editForm={onEdit}
              printForm={() => onPrint(handlePrint)}
              closeForm={() => onCancel()}
            />
          )}
          <Box ref={componentRef}>
            <GroupContainer
              id="null"
              title={langStore.groupShowcaseLineLabel}
              collapsible={false}
            >
              <FormControl fullWidth>
                <ShowMultiLine
                  value={concept}
                  label={langStore.ShowcaseLineConceptLabel}
                />
                <ShowNumber
                  value={quantity}
                  label={langStore.ShowcaseLineQuantityLabel}
                />
                <ShowNumber
                  value={unitPrice}
                  label={langStore.ShowcaseLineUnitPriceLabel}
                  decimalScale={2}
                  prefix={"$"}
                  thousandSeparator={","}
                  fixedDecimalScale={true}
                />
                <ShowMultiLine
                  value={note}
                  label={langStore.ShowcaseLineNoteLabel}
                />
              </FormControl>
            </GroupContainer>
          </Box>
        </Grid>
      );
    }
  );
